module.exports = __webpack_public_path__ + "assets/img/img_ztbj.15ebf496.png";